import { IconBranchFill } from '@saucelabs/ds-icons';
import PlatformIcon from '@saucelabs/sl-component-platform-icon';
import React from 'react';

import { DiffStatus, Scalars } from '../../graphql/__generated__/graphql';
import { TimeMode, formatDate } from '../common/DateLabel';
import Metadata from '../common/Metadata';

export const getStageStatusInfo = (
  itemStatus: DiffStatus,
  itemAuthor?: string,
  itemDate?: Scalars['Datetime'],
) => {
  switch (itemStatus) {
    case DiffStatus.Equal:
      return 'Snapshot is equal to the baseline.';
    case DiffStatus.Approved:
    case DiffStatus.Rejected:
      if (itemDate) {
        const authorInfo = itemAuthor ? ` by @${itemAuthor}` : '';
        const statusInfo = itemStatus.charAt(0) + itemStatus.substring(1).toLowerCase();
        return `${statusInfo}${authorInfo} ${formatDate[TimeMode.SHORT](itemDate)}`;
      }

      return '';
    default:
      return '';
  }
};

export type DiffStageMetaProps = {
  status: DiffStatus,
  updatedAt?: Scalars['Datetime'],
  updatedBy?: string,
  branch?: string,
  browser?: string,
  browserVersion?: string,
  operatingSystem?: string,
  operatingSystemVersion?: string,
  device?: string,
  viewportHeight?: number,
  viewportWidth?: number,
}

export const DiffStageMeta: React.FC<DiffStageMetaProps> = ({
  status,
  updatedAt,
  updatedBy,
  branch,
  browser,
  browserVersion,
  operatingSystem,
  operatingSystemVersion,
  device,
  viewportHeight,
  viewportWidth,
}) => {
  const statusInfo = getStageStatusInfo(status, updatedBy, updatedAt);

  const meta = [
    <Metadata
      hide={!browser}
      icon={(
        <PlatformIcon
          className="fill-current"
          name={browser || ''}
        />
      )}
      label={browserVersion}
    />,
    <Metadata
      hide={!(operatingSystem || device)}
      icon={operatingSystem ? (
        <PlatformIcon
          className="fill-current"
          name={operatingSystem}
        />
      ) : undefined}
      label={operatingSystemVersion ?? ''}
      secondLabel={device ?? ''}
      truncate
    />,

    <Metadata
      hide={!(viewportHeight && viewportWidth)}
      label={`${viewportWidth ?? ''} x ${viewportHeight ?? ''}`}
      truncate
    />,

    <Metadata
      hide={!branch}
      icon={<IconBranchFill className="h-2 w-2 fill-current" />}
      label={branch}
      truncate
    />,
    <Metadata
      className="min-w-12"
      hide={!statusInfo}
      label={statusInfo}
      truncate
    />,
  ].filter((item) => !item.props.hide);

  if (!meta.length) {
    return null;
  }

  return (
    <div className="flex flex-shrink gap-0.5 justify-center items-center text-medium-emphasis min-w-0">
      {meta.map((item, i) => (
        <>
          {i > 0 && <span className="text-base mx-0.5">|</span>}
          {item}
        </>
      ))}
    </div>
  );
};

export default DiffStageMeta;
